<template>
    <div class='h-dialogContainer'>
        <div class='row h-row-around-inputBox'>
            <div class='col-sm-6'>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.resourceName')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.neTypeName">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.resourceVersion')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.neTypeVersion">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.counterName')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.counterName">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.counterUnit')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.unitName">
                    </div>
                </div>
            </div>

            <div class='col-sm-6'>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.promptAlarm')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.level3Value">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.secondaryAlarm')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.level2Value">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.importantAlarm')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.level1Value">
                    </div>
                </div>
                <div class='h-col-inputBox'>
                    <div class="h-inputLit">{{this.$t('Pm.emergencyAlarm')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                        <input class="e-control e-textbox e-lib e-input" :readonly="true" name="level4Lower" type="text" v-model="detailParams.level0Value">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ThresholdDetailDialog",
        data(){
            return {
                detailParams: {
                    neTypeName: '',
                    neTypeVersion: '',
                    counterName: '',
                    unitName: '',
                    level0Value: '',
                    level1Value: '',
                    level2Value: '',
                    level3Value: '',
                }
            }
        }
    }
</script>

<style scoped>

</style>
